module.exports = {
    getEachHalfHour: function (startTime, endTime) {
        var toInt  = time => ((h,m) => h*2 + m/30)(...time.split(':').map(parseFloat)),
            toTime = int => [Math.floor(int/2), int%2 ? '30' : '00'].join(':'),
            range  = (from, to) => Array(to-from+1).fill().map((_,i) => from + i),
            eachHalfHour = (startTime, endTime) => range(...[startTime, endTime].map(toInt)).map(toTime);
        return eachHalfHour(startTime, endTime);
    },
    fillTimes: function(reservedTimes, selectedDate) {
        var slots = document.getElementsByClassName("select-slot");
        for (var i = 0; i < slots.length; i++) {
          let currentFieldDisabled = this.fieldDisabled(slots.item(i).dataset.time, selectedDate)
            slots.item(i).setAttribute('data-disabled', currentFieldDisabled);
            if (currentFieldDisabled) {
              slots.item(i).innerHTML = '-';
              slots.item(i).classList.add('selected');
            } else {
              slots.item(i).innerHTML = '+';
              slots.item(i).classList.remove('selected');
            }
            if (reservedTimes !== null && reservedTimes[slots.item(i).dataset.court] !== undefined) {
                let tempReservedTimes = reservedTimes[slots.item(i).dataset.court][0];
                if (tempReservedTimes !== undefined) {
                    let timeIndex = tempReservedTimes.indexOf(('0' + slots.item(i).dataset.time).slice(-5));
                    if (timeIndex > -1) {
                        slots.item(i).setAttribute('data-disabled', 'true');
                        slots.item(i).classList.add('selected');
                        slots.item(i).innerHTML = '-';
                    }
                }
            }

        }
    },
    fieldDisabled: function(time, selectedDate) {
      if (selectedDate > new Date()) {
        return false
      }
      time = Number(time.replace(':',''))
      let currentDate = new Date()
      let hours = currentDate.getHours()
      let minutes = (currentDate.getMinutes() < 10 ? '0' : '') + currentDate.getMinutes()
      return Number(hours + minutes) > time
    }
}



// WEBPACK FOOTER //
// ./src/helpers/calendar.js